module.exports = __webpack_public_path__ + "static/img/tg.025deae8.svg";